var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.can('fivesclub_membership_show_membership_list'))?_c('ListMemberships',{on:{"set-tab-index":_vm.setTabIndex}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }